export const GET_ALL_SETTINGS = "GET_ALL_SETTINGS";
export const GET_ALL_SETTINGS_SUCCESS = "GET_ALL_SETTINGS_SUCCESS";
export const GET_ALL_SETTINGS_FAILURE = "GET_ALL_SETTINGS_FAILURE";

export const EDIT_SETTINGS = "EDIT_SETTINGS";
export const EDIT_SETTINGS_SUCCESS = "EDIT_SETTINGS_SUCCESS";
export const EDIT_SETTINGS_FAILURE = "EDIT_SETTINGS_FAILURE";

